<template>
  <div class="global-footer-page-top-block">
    <p><a :href="topScrollElementId" class="global-footer-page-top" @click="moveSmoothScroll">ページトップへ</a></p>
  </div>
</template>

<script>
import smoothScroll from 'smoothscroll';

export default {
  name : 'page-top-scroll',
  props: {
    topScrollElementId: {
      type   : String,
      default: '',
    },
  },
  methods: {
    moveSmoothScroll: function(e) {
      e.preventDefault();
      const target = this.$el.ownerDocument.querySelector(this.topScrollElementId);
      smoothScroll(target);
    },
  },
};
</script>
